


















import BackgroundCover from '@/components/BackgroundCover.vue';
import ChromeWrapper from '@/components/chrome/Wrapper.vue';
import MenuBar from '@/components/chrome/MenuBar.vue';
import Logo from '@/components/Logo.vue';

export default {
  props: {
    enabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BackgroundCover,
    ChromeWrapper,
    Logo,
    MenuBar,
  },
} as IView;
